import React from 'react';
import { initSimpleImg } from 'react-simple-img';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import MainLayout from '../../containers/MainLayout/MainLayout';
import MainInfo from '../MainInfo';
import MainSteps from '../Steps/MainSteps';
import MainList from '../MainList';
import './style.sass';

const HomeComponent = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const {
    featuredLocations,
    popularLocations,
    topBlockContent,
    bottomBlockContent,
    footerData,
  } = props;

  initSimpleImg({ rootMargin: '0px 0px 300px 0px' });

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <MainInfo content={topBlockContent} />
          <MainSteps />
          <MainList popularLocations={popularLocations} featuredLocations={featuredLocations} />
          <div className="bottom-section container">
            <div className="bordered-section" dangerouslySetInnerHTML={{ __html: bottomBlockContent }} />
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};


HomeComponent.propTypes = {
  featuredLocations: PropTypes.oneOfType([PropTypes.object]),
  popularLocations: PropTypes.oneOfType([PropTypes.object]),
  topBlockContent: PropTypes.oneOfType([PropTypes.object]),
  bottomBlockContent: PropTypes.string,
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

HomeComponent.defaultProps = {
  featuredLocations: [],
  popularLocations: [],
  topBlockContent: {},
  bottomBlockContent: '',
  footerData: {},
};

export default HomeComponent;
